'use client';
import Image from 'next/image';

const galleryImages = [
  '/images/event-highlights/gallery-01.webp',
  '/images/event-highlights/gallery-05.webp',
  '/images/event-highlights/gallery-03.webp',
  '/images/event-highlights/gallery-04.webp',
  '/images/event-highlights/picture.webp',
  '/images/event-highlights/crowd.webp',
  '/images/event-highlights/people-pic.webp',
  '/images/event-highlights/discussion.webp',
  '/images/event-highlights/selfie.webp',
  '/images/event-highlights/network.webp',
  '/images/event-highlights/happy-era.webp',
  '/images/event-highlights/professionals.webp',
  // '/images/event-highlights/event-crowd.webp',
  // '/images/event-highlights/gaminglab-event.webp',
  // '/images/event-highlights/gaminglab-event-after.webp',
  // '/images/event-highlights/networking.webp',
  // '/images/event-highlights/post-dicussion.webp',
  // '/images/event-highlights/number-exchnage.webp',
  // '/images/event-highlights/event-era.webp',
  // '/images/event-highlights/welcom-to-gaming-lab-event.webp',
  
];

export default function GallerySection() {
  return (
 <section data-component-id="src/app/GallerySection.tsx:30:1" data-component-path="src/app/GallerySection.tsx" data-component-line="30" data-component-file="GallerySection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22events-highlights%22%2C%22className%22%3A%22w-full%20max-w-%5B1440px%5D%20mx-auto%20px-4%20py-10%22%7D" id='events-highlights' className="w-full max-w-[1440px] mx-auto px-4 py-10">     
<h2 data-component-id="src/app/GallerySection.tsx:31:0" data-component-path="src/app/GallerySection.tsx" data-component-line="31" data-component-file="GallerySection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B24px%5D%20sm%3Atext-%5B30px%5D%20md%3Atext-%5B34px%5D%20lg%3Atext-%5B38px%5D%20font-bold%20leading-%5B30px%5D%20sm%3Aleading-%5B37px%5D%20md%3Aleading-%5B42px%5D%20lg%3Aleading-%5B47px%5D%20text-center%20text-text-primary%20w-auto%20mb-10%22%2C%22textContent%22%3A%22Event%20Highlights%22%7D" className="text-[24px] sm:text-[30px] md:text-[34px] lg:text-[38px] font-bold leading-[30px] sm:leading-[37px] md:leading-[42px] lg:leading-[47px] text-center text-text-primary w-auto mb-10" style={{ fontFamily: 'Montserrat' }}
            >
              Event Highlights
            </h2>

      {/* Gallery Grid */}
      <div data-component-id="src/app/GallerySection.tsx:37:6" data-component-path="src/app/GallerySection.tsx" data-component-line="37" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-%5B1200px%5D%20mx-auto%20grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20gap-3%20sm%3Agap-4%22%7D" className="max-w-[1200px] mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
        {galleryImages.map((src, index) => (
          <div data-component-id="src/app/GallerySection.tsx:39:10" data-component-path="src/app/GallerySection.tsx" data-component-line="39" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20group%20overflow-hidden%20rounded-lg%22%7D"
            key={index}
            className="relative group overflow-hidden rounded-lg"
          >
            <Image data-component-id="src/app/GallerySection.tsx:43:12" data-component-path="src/app/GallerySection.tsx" data-component-line="43" data-component-file="GallerySection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%20transition-transform%20duration-500%20group-hover%3Ascale-105%22%7D"
              src={src}
              alt={`Gallery ${index + 1}`}
              width={500}
              height={500}
              unoptimized
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />

            {/* Gradient Overlay */}
            <div data-component-id="src/app/GallerySection.tsx:53:12" data-component-path="src/app/GallerySection.tsx" data-component-line="53" data-component-file="GallerySection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20group-hover%3Aopacity-0%20transition-opacity%20duration-500%22%7D" className="absolute inset-0 group-hover:opacity-0 transition-opacity duration-500" />
          </div>
        ))}
      </div>
    </section>
  );
}
